import React,{useState,useEffect} from 'react';
import { connect } from 'react-redux';
import { Button, Tooltip } from 'antd';
import { getList } from '../Utils/FormCalls';
import StyledTable from '../../../commons/styles/table';
import { MASTERDATASOURCE } from '../../../commons/api';
import { EditOutlined, EyeOutlined } from '@ant-design/icons';
import themeSettings from '../../../commons/styles/themeSettings.json';
const APIList = {
  getList: `${MASTERDATASOURCE.GET}`
};
const DataSourceMastersList = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  useEffect(() => {
    const fetchData = async () => {
      const response = await getList(APIList.getList);
      setDataSource(response && Array.isArray(response) ? response : []);
    };
    fetchData();
  }, []);
  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache]);
  const viewRecord = (e, record) => {
    e.preventDefault();
    props.navigate(`/rubus/RbsAnalytics/DataSourceMastersDetails/${record.Id}`, {
      state: { viewTag: true }
    });
  };
  const editRecord = (record) => {
    props.navigate(`/rubus/RbsAnalytics/DataSourceMastersDetails/${record.Id}`, {
      state: { editTag: true }
    });
  };
  const translation = (keyword) => {
    return translationCache[keyword] || keyword;
  };
    const columns = [
      {
        title: translation('DataSource Name'),
        dataIndex: 'Name',
        key: 'Name'
      },
      {
        title: translation('DataSource Code'),
        dataIndex: 'Code',
        key: 'Code'
      },
      {
        title: translation('Type'),
        dataIndex: 'Type',
        key: 'Type'
      },
      {
        title: translation('Sub Type'),
        dataIndex: 'SourceType',
        key: 'SourceType'
      },
      {
        title: translation('Status'),
        dataIndex: 'Status',
        key: 'Status'
        // render: (text, record, index) => {
        //   return (
        //     <span>
        //       <Switch
        //         // checkedChildren={
        //         //   translationCache && translationCache["ON"]
        //         //     ? translationCache["ON"]
        //         //     : "ON"
        //         // }
        //         // unCheckedChildren={
        //         //   translationCache && translationCache["OFF"]
        //         //     ? translationCache["OFF"]
        //         //     : "OFF"
        //         // }
        //         // checked={record.NotificationStatus}
        //         // onChange={() => {
        //         //   // e.stopPropagation();
        //         //   ruleStatusUpdate(record, index);
        //         // }}
        //       />
        //     </span>
        //   );
        // },
      },
      {
        title: translation('Action'),
        width: '600',
        render: (text, record) => (
          <>
            <Button
              type="primary"
              onClick={(e) => {
                viewRecord(e, record);
              }}
              style={{ marginRight: '10px' }}
            >
              <EyeOutlined />
            </Button>
            <Button
              type='primary'
              style={{ marginRight: '5px' }}
              onClick={() => {
                editRecord(record);
              }}
              
            >
              <EditOutlined />
            </Button>
          </>
        )
      }
    ];
    return (
      <>
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Tooltip title={translation('Click here to add a new DataSource')}>
            <Button
              onClick={() => props.navigate('/rubus/RbsAnalytics/DataSourceMastersDetails')}
              type="primary"
              style={{
                marginBottom: 8
              }}
              
            >
              {translation('New')}
            </Button>
          </Tooltip>
        </div>
        <StyledTable size="small"
          theme={themeSettings}
          dataSource={dataSource && Array.isArray(dataSource) ? dataSource : []}
          columns={columns}
        ></StyledTable>
      </>
    );
};
const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});
export default connect(mapStateToProps)(DataSourceMastersList);
